import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Button,
} from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function ImpressumPage() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0a1929' }}>
      {/* Navigation */}
      <AppBar 
        position="fixed" 
        elevation={0}
        sx={{
          background: 'rgba(10, 25, 41, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(0, 180, 216, 0.1)',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component={Link}
                to="/"
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1.5,
                  background: 'linear-gradient(135deg, #00b4d8, #14b8a6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textDecoration: 'none',
                }}
              >
                <TimelineIcon sx={{ color: 'white', fontSize: 24 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#e2e8f0' }}>
                DZ Content Factory
              </Typography>
            </Box>
            
            <Button
              component={Link}
              to="/"
              startIcon={<ArrowBackIcon />}
              sx={{ color: '#e2e8f0' }}
            >
              Zurück
            </Button>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ pt: 14, pb: 8 }}>
        <Paper
          sx={{
            p: { xs: 3, md: 6 },
            background: 'linear-gradient(135deg, rgba(16, 42, 67, 0.95), rgba(36, 59, 83, 0.95))',
            border: '1px solid rgba(0, 180, 216, 0.15)',
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 700, color: '#e2e8f0', mb: 4 }}>
            Impressum
          </Typography>

          <Box sx={{ color: '#e2e8f0', lineHeight: 1.8 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Angaben gemäß § 5 TMG
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              DiKItal Solutions<br />
              Am Sportplatz 22<br />
              07552 Gera<br />
              Deutschland
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Vertreten durch
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Ronny Elsner
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Kontakt
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Telefon: +49 365 773 184 89<br />
              E-Mail: info@dikitalsolutions.com
            </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
              Umsatzsteuer-Ident.-Nr. nach § 27 a UStG: DE367843683
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Haftung für externe Links
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Wir übernehmen keine Haftung für Inhalte externer Internet-Seiten, auf die durch
              unsere Links zugegriffen werden kann. Für deren Inhalte sind ausschließlich
              deren Betreiber verantwortlich.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Datenschutz
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Der Anbieter weist ausdrücklich darauf hin, dass die Datenübertragung im
              Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht
              lückenlos vor dem Zugriff durch Dritte geschützt werden kann. Die Verwendung der
              Kontaktdaten des Impressums zur gewerblichen Werbung ist ausdrücklich nicht
              erwünscht, es sei denn der Anbieter hatte zuvor seine schriftliche Einwilligung
              erteilt oder es besteht bereits eine Geschäftsbeziehung. Der Anbieter und alle auf
              dieser Website genannten Personen widersprechen hiermit jeder kommerziellen
              Verwendung und Weitergabe ihrer Daten.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              Personenbezogene Daten
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Sie können unsere Webseite ohne Angabe personenbezogener Daten besuchen. Soweit
              auf unseren Seiten personenbezogene Daten (wie Name, Anschrift oder E-Mail
              Adresse) erhoben werden, erfolgt dies, soweit möglich, auf freiwilliger Basis. Diese
              Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
              Sofern zwischen Ihnen und uns ein Vertragsverhältnis begründet, inhaltlich
              ausgestaltet oder geändert werden soll oder Sie an uns eine Anfrage stellen, erheben
              und verwenden wir personenbezogene Daten von Ihnen, soweit dies zu diesen Zwecken
              erforderlich ist (Bestandsdaten). Wir erheben, verarbeiten und nutzen
              personenbezogene Daten soweit dies erforderlich ist, um Ihnen die Inanspruchnahme des
              Webangebots zu ermöglichen (Nutzungsdaten). Sämtliche personenbezogenen Daten
              werden nur solange gespeichert wie dies für den genannten Zweck (Bearbeitung Ihrer
              Anfrage oder Abwicklung eines Vertrags) erforderlich ist. Hierbei werden steuer-
              und handelsrechtliche Aufbewahrungsfristen berücksichtigt.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export function PrivacyPage() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0a1929' }}>
      {/* Navigation */}
      <AppBar 
        position="fixed" 
        elevation={0}
        sx={{
          background: 'rgba(10, 25, 41, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(0, 180, 216, 0.1)',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component={Link}
                to="/"
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1.5,
                  background: 'linear-gradient(135deg, #00b4d8, #14b8a6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textDecoration: 'none',
                }}
              >
                <TimelineIcon sx={{ color: 'white', fontSize: 24 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#e2e8f0' }}>
                DZ Content Factory
              </Typography>
            </Box>
            
            <Button
              component={Link}
              to="/"
              startIcon={<ArrowBackIcon />}
              sx={{ color: '#e2e8f0' }}
            >
              Zurück
            </Button>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ pt: 14, pb: 8 }}>
        <Paper
          sx={{
            p: { xs: 3, md: 6 },
            background: 'linear-gradient(135deg, rgba(16, 42, 67, 0.95), rgba(36, 59, 83, 0.95))',
            border: '1px solid rgba(0, 180, 216, 0.15)',
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 700, color: '#e2e8f0', mb: 4 }}>
            Datenschutzerklärung
          </Typography>

          <Box sx={{ color: '#e2e8f0', lineHeight: 1.8 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              1. Datenschutz auf einen Blick
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Allgemeine Hinweise
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
              Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter
              diesem Text aufgeführten Datenschutzerklärung.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Datenerfassung auf dieser Website
            </Typography>
            <Typography variant="body1" component="div" sx={{ mb: 3 }}>
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
              Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle"
              in dieser Datenschutzerklärung entnehmen.
            </Typography>

            <Typography variant="body1" component="div" sx={{ mb: 3 }}>
              <strong>Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen.
              Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der
              Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
              Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
              dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </Typography>

            <Typography variant="body1" component="div" sx={{ mb: 3 }}>
              <strong>Wofür nutzen wir Ihre Daten?</strong><br />
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website
              zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens
              verwendet werden.
            </Typography>

            <Typography variant="body1" component="div" sx={{ mb: 3 }}>
              <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger
              und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben
              außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn
              Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese
              Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
              unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
              personenbezogenen Daten zu verlangen.
            </Typography>

            <Typography variant="h5" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              2. Hosting
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              <strong>NetCup GmbH</strong><br />
              Daimlerstraße 25<br />
              76185 Karlsruhe
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben
              genannten Dienstes geschlossen. Hierbei handelt es sich um einen
              datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die
              personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung
              der DSGVO verarbeitet.
            </Typography>

            <Typography variant="h5" sx={{ fontWeight: 600, color: '#00b4d8', mb: 2, mt: 4 }}>
              3. Allgemeine Hinweise und Pflichtinformationen
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Datenschutz
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr
              ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den
              gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Hinweis zur verantwortlichen Stelle
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              DiKItal Solutions<br />
              Ronny Elsner<br />
              Am Sportplatz 22<br />
              07552 Gera<br />
              Telefon: +49 365 773 184 89<br />
              E-Mail: info@dikitalsolutions.com
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Speicherdauer
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer
              genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für
              die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend
              machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
              gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die
              Speicherung Ihrer personenbezogenen Daten haben.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Widerruf Ihrer Einwilligung zur Datenverarbeitung
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
              möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die
              Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
              Widerruf unberührt.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Recht auf Datenübertragbarkeit
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
              Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten
              in einem gängigen, maschinenlesbaren Format aushändigen zu lassen.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#14b8a6', mb: 2, mt: 3 }}>
              Auskunft, Löschung und Berichtigung
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht
              auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten,
              deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht
              auf Berichtigung oder Löschung dieser Daten.
            </Typography>

            <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid rgba(0, 180, 216, 0.2)' }}>
              <Typography variant="body2" color="text.secondary">
                Quelle: e-recht24.de (angepasst)
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
